import axios from "shared/api/axiosConfig";
import { encryptApiBodyFromJSON } from "shared/api/cryptApiBody";

/**
 * Vérification email uniquement
 * @param {string} email - L'adresse email à vérifier
 * @param {string} type - Le type d'utilisateur
 * @returns {Promise} - Réponse de l'API
 */
export async function createTrustfullEmail(email, type) {
    try {
        console.log('Appel API email avec:', { email, type });
        const response = await axios.post("/client/trustfull/enrich/email", {
            encrypt: encryptApiBodyFromJSON({ email }),
            type
        });
        console.log('Réponse API email:', response);
        return response;
    } catch (error) {
        console.error('Erreur API email:', error);
        throw error;
    }
}

/**
 * Vérification téléphone uniquement
 * @param {string} phone_number - Le numéro de téléphone à vérifier
 * @param {string} type - Le type d'utilisateur
 * @returns {Promise} - Réponse de l'API
 */
export async function createTrustfullPhone(phone_number, type) {
    try {
        console.log('Appel API téléphone avec:', { phone_number, type });
        const response = await axios.post("/client/trustfull/enrich/phone", {
            encrypt: encryptApiBodyFromJSON({ phone_number }),
            type
        });
        console.log('Réponse API téléphone:', response);
        return response;
    } catch (error) {
        console.error('Erreur API téléphone:', error);
        throw error;
    }
}

/**
 * Vérification email + téléphone
 * @param {string} email - L'adresse email à vérifier
 * @param {string} phone_number - Le numéro de téléphone à vérifier
 * @param {string} type - Le type d'utilisateur
 * @returns {Promise} - Réponse de l'API
 */
export async function createTrustfullEmailPhone(email, phone_number, type) {
    try {
        console.log('Appel API email+téléphone avec:', { email, phone_number, type });
        const response = await axios.post("/client/trustfull/enrich/email-phone", {
            encrypt: encryptApiBodyFromJSON({ email, phone_number }),
            type
        });
        console.log('Réponse API email+téléphone:', response);
        return response;
    } catch (error) {
        console.error('Erreur API email+téléphone:', error);
        throw error;
    }
}

/**
 * Vérification conditionnelle flexible
 * @param {string} verification_type - Type de vérification ('email', 'phone', 'email_phone')
 * @param {Object} data - Données à vérifier
 * @param {string} type - Le type d'utilisateur
 * @returns {Promise} - Réponse de l'API
 */
export async function createTrustfullConditional(verification_type, data, type) {
    try {
        console.log('Appel API conditionnel avec:', { verification_type, data, type });
        const response = await axios.post("/client/trustfull/enrich/conditional", {
            encrypt: encryptApiBodyFromJSON({ verification_type, ...data }),
            type
        });
        console.log('Réponse API conditionnel:', response);
        return response;
    } catch (error) {
        console.error('Erreur API conditionnel:', error);
        throw error;
    }
}

